import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { MapperService } from '@services/mapper.service';
import { map, } from 'rxjs/operators';
import { ODataService } from './generics/odata.service';
var WebhookService = /** @class */ (function (_super) {
    tslib_1.__extends(WebhookService, _super);
    function WebhookService(http) {
        var _this = _super.call(this, http, MapperService.webhookMap) || this;
        _this._endpoint = '/odata/Webhooks';
        return _this;
    }
    WebhookService.prototype.getEventTypeGroups = function () {
        var _this = this;
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetEventTypes")
            .pipe(map(function (response) { return _this._mapData(response, MapperService.webhookEventTypeMap); }), map(function (response) {
            // we map only one-level groups because that's what we get from the server
            return response.data.reduce(function (accumulator, current) {
                var _a;
                var group = accumulator.find(function (obj) { return Object.keys(obj).includes(current.group); });
                if (group) {
                    group[current.group].push(current.name);
                }
                else {
                    accumulator.push((_a = {},
                        _a[current.group] = [current.name],
                        _a));
                }
                return accumulator;
            }, []).sort(function (a, b) {
                var aKey = Object.keys(a)[0];
                var bKey = Object.keys(b)[0];
                return b[bKey].length -
                    a[aKey].length;
            });
        }));
    };
    WebhookService.prototype.verifyHost = function (url) {
        return this._http.get("/api/Status/VerifyHostAvailibility?url=" + url);
    };
    WebhookService.prototype.toggleEnabled = function (webhook) {
        return this.patch(webhook.id, { enabled: webhook.enabled });
    };
    return WebhookService;
}(ODataService));
export { WebhookService };
